import script from "./MoleculeDataCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeDataCard.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeDataCard.vue?vue&type=style&index=0&id=7194a2d5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7194a2d5"]])

export default __exports__